import React from 'react';
import * as Icons from 'lucide-react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { PageHero, CTASection } from '@/components/shared/Section';
import { SERVICES } from '@/data/content';
import { useLocation } from 'react-router-dom';

export default function ServicesPage() {
  const { hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace('#', ''));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  }, [hash]);

  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Six service pillars built around how businesses actually grow."
        description="From recruitment and employer branding to corporate setup — practical, integrated services designed for ambitious businesses across the GCC."
      />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-24">
        <div className="grid gap-16 md:gap-24">
          {SERVICES.map((s, idx) => {
            const Icon = Icons[s.icon] || Sparkles;
            const reverse = idx % 2 === 1;
            return (
              <article
                key={s.slug}
                id={s.slug}
                data-testid={`service-detail-${s.slug}`}
                className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center scroll-mt-24`}
              >
                <div className={`lg:col-span-5 ${reverse ? 'lg:order-2' : ''}`}>
                  <div className="relative">
                    <div className="aspect-[4/5] rounded-sm overflow-hidden bg-[#003B73] text-white p-10 flex flex-col justify-between border border-slate-200">
                      <div className="inline-flex h-14 w-14 items-center justify-center rounded-sm bg-tito-gold/20 text-tito-gold">
                        <Icon className="h-7 w-7" />
                      </div>
                      <div>
                        <div className="font-display font-bold text-2xl">0{idx + 1}</div>
                        <div className="mt-2 eyebrow text-tito-gold">{s.title.split(' ')[0]}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`lg:col-span-7 ${reverse ? 'lg:order-1' : ''}`}>
                  <div className="eyebrow text-tito-blue/70">Service Pillar 0{idx + 1}</div>
                  <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl tracking-tight text-slate-900">
                    {s.title}
                  </h2>
                  <p className="mt-5 text-slate-600 leading-relaxed text-lg">{s.short}</p>
                  <ul className="mt-8 grid sm:grid-cols-2 gap-3">
                    {s.items.map((it) => (
                      <li key={it} className="flex items-start gap-3 p-4 rounded-sm bg-white border border-slate-200">
                        <CheckCircle2 className="h-5 w-5 text-tito-gold shrink-0 mt-0.5" />
                        <span className="text-sm text-slate-700 font-medium">{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <CTASection />
    </>
  );
}
